export enum QueryParamsModel {
  LastName = "surname",
}



// WEBPACK FOOTER //
// ./src/app/_models/query-params.ts